import { defer, each } from 'lodash-es';
import Component from 'navigation/component/Component';
import capency, { CAPENCY_DEFAULT_COUNTRIES } from 'helpers/capency';
import config from 'core/config';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import GooglePlacesField from 'components/address-field/GooglePlacesField';
import CapencyField from 'components/address-field/CapencyField';
class AddressForm extends Component {
    prefix;
    stateInput;
    countryInput;
    statesByCountry;
    form;
    status = 'empty';
    suggestions;
    capencyCountries = CAPENCY_DEFAULT_COUNTRIES;
    _useCapency = null;
    selectedAddress = null;
    set useCapency(value) {
        if (this._useCapency !== value) {
            this._useCapency = value;
            this.fillAddress({
                address: '',
                address2: '',
                city: '',
                postcode: ''
            });
        }
        this.refresh();
    }
    get useCapency() {
        return this._useCapency;
    }
    constructor(el, options) {
        super(el, options);
        this.form = this.parent;
        defer(() => {
            if (this.parent?.name !== 'Form')
                throw new Error('AddressForm must be a child of a Form');
        });
        this.prefix = el.getAttribute('data-prefix');
        const country = this.el.querySelector('select[autocomplete="country"]');
        this._useCapency = this.capencyCountries.includes(country?.value);
        this.parseForm();
    }
    initialized() {
        super.initialized();
        this.getCapencyAvailableCountries();
    }
    async getCapencyAvailableCountries() {
        this.onCountryUpdate();
        try {
            const countries = await capency.getAvailableCountries();
            this.capencyCountries = countries;
            this.onCountryUpdate();
        }
        catch (e) {
            this.onCountryUpdate();
        }
    }
    getModulesMap() {
        if (this.useCapency) {
            return {
                capencyField: ['input[autocomplete="street-address"]', CapencyField]
            };
        }
        else {
            return {
                googlePlacesField: ['input[autocomplete="street-address"]', GooglePlacesField]
            };
        }
    }
    bindEvents(add = true) {
        const method = bindMethod(add);
        const emitterMethod = bindEmitterMethod(add);
        this.countryInput[method]('change', this.onCountryUpdate);
        if (this.useCapency) {
            this.modules?.capencyField?.[emitterMethod]('select', this.onAddressSelected);
            this.modules?.capencyField?.[emitterMethod]('input', this.onAddressInput);
            if (this.refs.confirmIncompleteAddress)
                this.refs.confirmIncompleteAddress[method]('click', this.verifyAddress.bind(this, true));
        }
        else {
            this.modules?.googlePlacesField?.[emitterMethod]('select', this.onAddressSelected);
            this.modules?.googlePlacesField?.[emitterMethod]('input', this.onAddressInput);
        }
        this.form[emitterMethod]('submit', this.verifyAddress.bind(this));
    }
    parseForm() {
        this.stateInput = this.el.querySelector('select[autocomplete="address-level1"]');
        if (!this.stateInput)
            return;
        this.statesByCountry = JSON.parse(this.stateInput.getAttribute('data-states'));
        this.countryInput = this.el.querySelector('select[autocomplete="country"]');
    }
    onCountryUpdate = () => {
        if (!this.stateInput)
            return;
        const country = this.countryInput.value;
        this.useCapency = this.capencyCountries?.includes(country);
        const states = this.statesByCountry[country];
        if (this.modules.capencyField)
            this.modules.capencyField.country = country;
        if (this.modules.googlePlacesField)
            this.modules.googlePlacesField.country = country;
        this.el.classList.toggle('with-states', !!states);
        this.el.classList.toggle('without-zipcode', country === 'HK');
        this.stateInput.innerHTML = '';
        this.status = 'empty';
        this.selectedAddress = null;
        if (country === 'MC') {
            this.fillAddress({
                city: 'MONACO'
            });
        }
        this.el.querySelector('.address__choices')?.remove();
        // this.status = 'empty'
        // this.selectedAddress = null
        this.form.quickValid();
        if (!states)
            return;
        each(states, (value, key) => {
            const option = document.createElement('option');
            option.value = key.toString();
            option.textContent = value;
            option.selected = this.stateInput.getAttribute('value') === key.toString();
            this.stateInput.appendChild(option);
        });
        this.form.quickValid();
    };
    onAddressInput = () => {
        this.el.querySelector('.address__choices')?.remove();
        this.status = 'empty';
        this.selectedAddress = null;
    };
    onAddressSelected = (address) => {
        this.selectedAddress = address;
        this.fillAddress(address);
    };
    verifyAddress = async (forced = false) => {
        if (!this.useCapency)
            return true;
        if (forced) {
            this.fillAddress(this.selectedAddress);
            this.form.submit();
        }
        const values = (this.prefix ? this.form.getAddressFormValues(this.el) : this.form.getFormValues());
        // If user selected a suggested address
        if (values.address_final_choice) {
            // if a user wish to keep the address he entered
            if (values.address_final_choice === '-1') {
                this.status = 'validated';
                return true;
            }
            const address = this.suggestions[parseInt(values.address_final_choice)];
            this.fillAddress({
                address: `${address.streetNumber || ''} ${address.streetName}`,
                city: address.locality,
                postcode: address.postalCode
            });
            this.status = 'validated';
            return true;
        }
        // Verify address
        const { addresses, error } = await capency.verifyAddress({
            streetName: `${values.address}`,
            postalCode: `${values.postcode}`,
            locality: values.city,
            country: values.country
        });
        // Remove older address suggestions
        this.el.querySelector('.address__choices')?.remove();
        const address = addresses?.address;
        if (!error && address) {
            const suggestedAddresses = address.filter(address => address.qualityCode !== '20');
            // if multiple addresses or address[0] does not match values.address, show a list of choices
            const notAMatch = address.length === 1 && address?.[0] && ((values.address !== `${address[0].streetNumber || ''} ${address[0].streetName}`) || (values.postcode !== address[0].postalCode) || (values.city !== address[0].locality));
            if (suggestedAddresses.length > 1 || notAMatch) {
                this.suggestions = suggestedAddresses;
                const addressesChoice = `
        <div class="address__choices">
          <h3>${address.length === 1 ? config.errors.capencyNotSure : config.errors.capencySuggestedAddress}</h3>
          <div class="address__choices-list">
            ${suggestedAddresses.map((address, index) => `
              <div class="radio">
                <input type="radio" class="radio__input" name="${this.prefix ? this.prefix + '[' : ''}address_final_choice${this.prefix ? ']' : ''}" id="choice${index}" value="${index}" required>
                <div class="radio__box"></div>
                <label class="radio__label" for="choice${index}">${address.streetNumber || ''} ${address.streetName}, ${address.postalCode} ${address.locality}</label>
              </div>
            `).join('')}
             <div class="radio">
                <input type="radio" class="radio__input" name="${this.prefix ? this.prefix + '[' : ''}address_final_choice${this.prefix ? ']' : ''}" id="choice-keep" value="-1" required>
                <div class="radio__box"></div>
                <label class="radio__label" for="choice-keep">${config.errors.capencyKeep} (${values.address} ${values.postcode} ${values.city})</label>
              </div>
          </div>
        </div>`;
                this.el.lastElementChild.insertAdjacentHTML('beforebegin', addressesChoice);
                this.status = 'pending_selection';
                return false;
            }
            if (address.length === 1) {
                // 00 Valid address
                // 04 Forced company possessing a CEDEX (business postcode)
                // 10 Uncertain address
                if (['00', '04', '10'].includes(address[0].qualityCode)) {
                    this.status = 'validated';
                    this.fillAddress({
                        address: `${address[0].streetNumber || ''} ${address[0].streetName}`,
                        address2: `${address[0].buildingName || '__IGNORE__'}`,
                        city: address[0].locality,
                        postcode: address[0].postalCode
                    });
                    return true;
                }
                else {
                    const addressesChoice = `
          <div class="address__choices">
            <h3>${config.errors.capencyNotSure}</h3>
              <div class="radio">
                <input type="radio" class="radio__input" name="address_final_choice" id="choice-keep" value="-1" required>
              </div>
              <span class="address__choice">${address[0].streetNumber || ''} ${address[0].streetName}, ${address[0].postalCode} ${address[0].locality}</span>
              <button type="button" value="${config.errors.capencyConfirm}" data-ref="confirmIncompleteAddress" data-text="${config.errors.capencyConfirm}" class="button button__hover-classic button__solid button__dark">
                <span class="button__inner">
                  <span class="button__text-wrapper">
                    <span class="button__text-inner" data-hover="${config.errors.capencyConfirm}"><span>${config.errors.capencyConfirm}</span></span>
                  </span>
                </span>
              </button>
            </div>
          </div>`;
                    this.el.lastElementChild.insertAdjacentHTML('beforebegin', addressesChoice);
                    this.bindEvents(false);
                    this.bindRefs();
                    this.bindEvents(true);
                    this.status = 'pending_selection';
                    this.fillAddress({
                        address: `${address[0].streetNumber || ''} ${address[0].streetName}`,
                        city: address[0].locality,
                        postcode: address[0].postalCode
                    });
                    return false;
                }
            }
        }
        else {
            console.log('error', error);
        }
    };
    fillAddress = (address) => {
        each(address, (value, key) => {
            const name = this.prefix ? `${this.prefix}[${key}]` : key;
            const input = this.el.querySelector(`[name="${name}"]`);
            if (!input || value === '__IGNORE__')
                return;
            input.value = value;
            if (key === 'country')
                this.onCountryUpdate();
        });
    };
}
export default AddressForm;
